import { useEffect, useMemo, useState } from "react"
import TreeAPI from "../../apis/TreeAPI";
import produce from "immer";
import { flatten } from "flat";

const useFree = () => {

    const [free, setFree] = useState<{
        [itemId: string]: true | undefined;
    }>({});

    useEffect(() => {
        const unsubscribe = TreeAPI.subscribeToFree(
            (data: IDBRealtimeFree) => {
                setFree(
                    produce(draft => {
                        const obj: any = flatten(data, {
                            delimiter: DELIMITER
                        });
                        if (typeof obj !== 'object') return {};

                        const objKeys = Object.keys(obj);

                        for (let index = 0; index < objKeys.length; index++) {
                            const key = objKeys[index];

                            if (obj[key] === true) {
                                const chunks = key.split(DELIMITER);
                                const id = chunks[chunks.length - 1] as string;
                                draft[id] = true;
                            }
                        }
                    })
                );
            }
        );
        return () => unsubscribe();
    }, []);

    const freeArray = useMemo(() => {
        const keys = Object.keys(free);

        const array: string[] = [];

        for (let index = 0; index < keys.length; index++) {
            const key = keys[index];
            array.push(key);
        }

        return array;
    }, [free]);

    return { free, freeArray };
}

const DELIMITER = '@DELIMITER@';

export { useFree }